import { useCallback, useState } from 'react'

const STORAGE_KEY = 'zeus.sidebar.navMode'

export type SidebarNavMode = 'full' | 'icons'

export function readSidebarNavMode(): SidebarNavMode {
  if (typeof window === 'undefined')
    return 'full'
  return localStorage.getItem(STORAGE_KEY) === 'icons' ? 'icons' : 'full'
}

export function persistSidebarNavMode(mode: SidebarNavMode) {
  localStorage.setItem(STORAGE_KEY, mode)
}

/**
 * Preferência persistente do menu lateral: texto completo ou apenas ícones + flyouts laterais.
 */
export function useSidebarNavMode(): [SidebarNavMode, (mode: SidebarNavMode) => void] {
  const [mode, setModeState] = useState<SidebarNavMode>(readSidebarNavMode)

  const setMode = useCallback((next: SidebarNavMode) => {
    setModeState(next)
    persistSidebarNavMode(next)
  }, [])

  return [mode, setMode]
}
